<!--
 * @Description: 项目人员管理-独立模块
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div style="height: 100%;background: #fff;padding: 20px 50px;">
    <el-radio-group v-model="tableType" style="margin-bottom: 10px;">
      <el-radio-button label="projectPersonTask">
        项目人员任务管理
      </el-radio-button>
      <el-radio-button label="projectSettlementTask">
        项目人员结算管理
      </el-radio-button>
    </el-radio-group>
    <table-render
      v-if="tableType === 'projectPersonTask'"
      style="padding: 0;"
      ref="tableRender"
      :getListFinished="getListFinished"
      :beforeInitPage="beforeInitPage"
      :config="config"
      :row-class-name="_getUnqualifiedRowConfig"
    />
    <ProjectPersonSettlement
      v-else-if="tableType === 'projectSettlementTask'"
    ></ProjectPersonSettlement>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import { agentManager } from '@/api/ajax';
import config from './config';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
import ProjectPersonSettlement from './child/projectPersonSettlement';
export default {
  name: 'ProjectPersonnelManage',
  provide() {
    return {
      indexPage: this // 把当前实例传递给后续弹层使用
    };
  },
  data() {
    return {
      tableType: 'projectPersonTask',
      config
    };
  },
  components: { tableRender, ProjectPersonSettlement },
  watch: {},
  computed: {},
  methods: {
    _getUnqualifiedRowConfig({ row, rowIndex }) {
      return getUnqualifiedRowConfig({
        row: {},
        rowIndex: rowIndex,
        isNotUnqualified: row.superviseStatus != 3
      });
    },
    //同步操作
    beforeInitPage(data) {
      data.respond.list = data.respond.list.map(item => {
        item.superviseStatus === 3 && (item.userAmount = 0);
        return {
          ...item,
          amountLoading: item.superviseStatus != 3
        };
      });
    },
    getListFinished(dataSor) {
      let arr = [];
      dataSor.list.forEach(item => {
        if (item.superviseStatus != 3) arr.push(item.userId);
      });
      if (arr.length) {
        agentManager
          .agentListAmount({
            userIds: String(arr),
            ...(this.$refs.tableRender.searchQuery || {})
          })
          .then(({ data: { data } }) => {
            dataSor.list = dataSor.list.map(item => {
              item.userAmount = data[item.userId] || 0;
              item.amountLoading = false;
              return item;
            });
          });
      }
    }
  },
  created() {
    this.tableType = this.$route.query.tableType || 'projectPersonTask';
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
